import * as React from 'react';
export default function useSelectOprate() {
  const data = React.useRef([]);
  function setAction(id, func) {
    const target = data.current.filter((item) => item.id === id);
    if (!target.length) {
      data.current = [...data.current, { id, action: func }];
    }
  }

  function setOptions(id, option) {
    const target = data.current.filter(
      (item) => item.id === id
    );
    if (target.length) {
      const action = target[0].action;
      action(option);
    }
  }

  return [
    {
      setAction,
      setOptions,
    },
  ];
}